import { createNode } from '@glueapp/graph-types';

export const Add = createNode({
    id: 'Add',
    name: 'Add',
    description: 'A Node for adding numbers',
    aiDescription:
        'Adds two numbers together. Connect values to "Number1" and "Number2" input ports; the "Result" output port provides the sum.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Number1: {
            kind: 'number',
        },
        Number2: {
            kind: 'number',
        },
    },
    outPorts: {
        Result: {
            kind: 'number',
        },
    },
    execute: function (input) {
        return { output: { Result: input.inPorts.Number1 + input.inPorts.Number2 } };
    },
});
